// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import React from 'react';

import { fg } from '@confluence/feature-gating';
import { LoadableBackground } from '@confluence/loadable';

export { useModernizeChangeboardingActive } from '@confluence/onboarding-helpers/entry-points/hooks/useModernizeChangeboardingActive';

const ModernizeChangeboardingLoadable = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ModernizeChangeboarding" */ './ModernizeChangeboarding'
			)
		).ModernizeChangeboarding,
});

export const ModernizeChangeboarding = () => {
	return fg('cc_modernize_ga_changeboarding') ? <ModernizeChangeboardingLoadable /> : null;
};
